export default {
  payChannel: 'Modalità di pagamento',
  cashierDesk: 'Cassa',
  billAddress: 'Indirizzo di fatturazione',
  paySuccess: 'Pagamento riuscito',
  payError: 'Pagamento fallito',
  harvestAddress: 'Indirizzo di spedizione',
  orderAddress: 'Indirizzo di fatturazione',
  selectAddress: 'Seleziona un indirizzo di spedizione',
  addOrderAddress: "Aggiungi prima l'indirizzo di fatturazione",
  addSelectAddress: 'Seleziona un indirizzo di spedizione',
  noAddress: 'Nessun indirizzo di spedizione disponibile',
  holder: {
    inputPayPwd: 'Imposta la password di pagamento',
    returnExchange: 'Pagamento non completato. Impossibile elaborare la richiesta di reso/scambio.',
  },
  transferTitle: 'Bonifico bancario',
  changeAddress: 'Cambia indirizzo',
  editText: 'Modifica',
  payWithbalance: 'Paga con il saldo acbuy',
  bankTransferRemittance: 'Bonifico bancario',
  transferTips:
    "0 commissioni di servizio su acbuy per il bonifico. Più alto è l'importo dell'ordine, maggiore è il risparmio!",
  pay: 'Offerte di ricarica',
  plsSetPsd: 'Imposta la password di pagamento',
  thirdPayTips: 'I pagamenti sono disponibili a livello globale e in più valute',
  payProcessing: 'Elaborazione del pagamento',
  payWaitingText: "Attendi 1-2 minuti, verifica l'esito del pagamento in seguito",
  coinpalTips:
    'Le ricariche di valuta digitale (valuta virtuale) non sono rimborsabili e non possono essere prelevate. Se accetti queste condizioni, procedi con la ricarica.',
}
